import { render, staticRenderFns } from "./errorDialog.vue?vue&type=template&id=3265979a&lang=pug"
import script from "./errorDialog.vue?vue&type=script&lang=js"
export * from "./errorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports